import styled from 'styled-components';

export const Container = styled.div`
	max-width: 480px;
	margin: 40px auto;
	background: #fff;
	border-radius: 12px;
	padding: 32px;
`;

export const Form = styled.form``;

export const FormLabel = styled.label`
	font-weight: 600;
	color: #222;
`;

export const FormInput = styled.input`
	width: 100%;
	padding: 10px;
	border-radius: 8px;
	border: 1px solid #e5e5e5;
	margin-top: 4px;
	font-size: 1rem;
	color: #222;
`;

export const FormTextarea = styled.textarea`
	width: 100%;
	padding: 10px;
	border-radius: 8px;
	border: 1px solid #e5e5e5;
	margin-top: 4px;
	min-height: 60px;
	font-size: 1rem;
	color: #222;
`;

export const FormError = styled.div`
	color: #d32f2f;
	font-size: 13px;
	margin-top: 2px;
`;

export const FormActions = styled.div`
	display: flex;
	gap: 16px;
	margin-top: 24px;
`;

export const FormMultiSelect = styled.select`
	width: 100%;
	padding: 10px;
	border-radius: 8px;
	border: 1px solid #e5e5e5;
	margin-top: 4px;
	font-size: 1rem;
	color: #222;
	min-height: 44px;
	background: #fff;
`;

export const TicketTypesContainer = styled.div`
	margin-top: 8px;
	margin-bottom: 18px;
	display: flex;
	flex-direction: column;
	gap: 12px;
`;

export const CheckboxContainer = styled.label`
	display: flex;
	align-items: center;
	gap: 10px;
	cursor: pointer;
`;

export const CheckboxButton = styled.input.attrs({ type: 'checkbox' })`
	width: 20px;
	height: 20px;
	border-radius: 6px;
	border: 2px solid #e86339;
	accent-color: #e86339;
	cursor: pointer;
`;

export const CheckboxText = styled.span`
	font-size: 1rem;
	color: #222;
	font-weight: 500;
`;
